import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Admin from "./pages/admin";
import Login from "./pages/authentication";
import Coordinator from "./pages/coordinator";
import Counsellor from "./pages/counsellor";
import Application from "./pages/Application/Application";
import Header from "./components/layout/header";
import { checkUser, getComponent } from "./assets/library";
import ProfileLayout, { DashboardRoutes } from "./pages/StudentProfile/profile";
import CustomModal from "./components/layout/customModal";
import { useAppSelector } from "./assets/hooks";
import PdfPreview from "./pages/Application/pdfPreview";
import Chat from "./pages/chats/chat";
import "./App.css";
import Calendar from "./pages/calendar/calendar";
import NotFound from "./components/layout/notFound";
import ProtectedRoute from "./protectedRoute";
import { FilterSelected } from "./types/types";
import Explore from "./pages/explore";
import Context from "./assets/constants/context";
import MyEditor from "./pages/counsellor/editor";
import Country from "./pages/counsellor/country";

function App() {
  const [appliedFilter, setAppliedFilter] = useState<FilterSelected[]>([]);
  const [selectedUniversities, setSelectedUniversities] = useState<FilterSelected[]>([]);


  const isRequested = useRef(false);
  useEffect(() => {
    if (!isRequested.current) {
      checkUser();
      isRequested.current = true;
    }
  }, []);
  const popup = useAppSelector((state) => state.popup);
  const Popupcomponent: React.FC<{ data: any }> | null =
  popup.data.show && popup.data.data?.container?.name
    ? getComponent(popup?.data?.data?.container?.name)
    : null;


  return (
    <div>
       <Context.Provider
        value={{
          selectedUniversities,
          setSelectedUniversities,
        }}
      >
      <BrowserRouter>
        <Header appliedFilter={appliedFilter} setAppliedFilter={setAppliedFilter}/>
       <Chat />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/explore" element={<Explore appliedFilter={appliedFilter} setAppliedFilter={setAppliedFilter} />} />

          <Route element={<ProtectedRoute link={"/"} />}>
          <Route path="/student/:id/*" element={<ProfileLayout />}>
            <Route index element={<DashboardRoutes />} />
          </Route>
          <Route path="/createBlog" element={<MyEditor />} />
          <Route path="/addcountry" element={<Country />} />
          <Route path="/application/:id" element={<Application />} />
          <Route path="/dashboard" element={<Counsellor />} />
          <Route path="/coordinator" element={<Coordinator />} />
          <Route path="/calendar-events" element={<Calendar />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/team/pdfPreview" element={<PdfPreview />} />
          <Route path="*" element={<NotFound/>} />
            </Route>
          

        </Routes>
        <CustomModal
            open={popup.data.show}
            additionalData={{
              width: popup.data.data?.container?.dimensions?.width,
            }}
          >
            {Popupcomponent ? (
              <Popupcomponent data={popup.data.data?.container?.data} />
            ) : null}
          </CustomModal>
      </BrowserRouter>
      </Context.Provider>
    </div>
  );
}

export default App;
